import { Check, Close } from '@element-plus/icons-vue'

export enum PartStatus {
  Good = 'Good',
  Fail = 'Fail',
  Irreparable = 'Irreparable',
  Unrepairable = 'Unrepairable',
  Replaced = 'Replaced',
  Repaired = 'Repaired',
  Blocked = 'Blocked',
  RepairNotAuthorized = 'Repair not authorized',
}

export enum PartDiagnosticStatus {
  Good = 'Good',
  Fail = 'Fail',
}

export const IsOkStatus: Record<PartStatus, boolean> = {
  [PartStatus.Good]: true,
  [PartStatus.Replaced]: true,
  [PartStatus.Repaired]: true,
  [PartStatus.Fail]: false,
  [PartStatus.Irreparable]: false,
  [PartStatus.Unrepairable]: false,
  [PartStatus.Blocked]: false,
  [PartStatus.RepairNotAuthorized]: false,
}

export const DiagnosticStatusIcons: Record<PartDiagnosticStatus, any> = {
  [PartDiagnosticStatus.Good]: Check,
  [PartDiagnosticStatus.Fail]: Close,
}

export const PartStatusToDiagnosticStatus: Record<PartStatus, PartDiagnosticStatus> = {
  [PartStatus.Good]: PartDiagnosticStatus.Good,
  [PartStatus.Replaced]: PartDiagnosticStatus.Fail,
  [PartStatus.Repaired]: PartDiagnosticStatus.Fail,
  [PartStatus.Fail]: PartDiagnosticStatus.Fail,
  [PartStatus.Irreparable]: PartDiagnosticStatus.Fail,
  [PartStatus.Unrepairable]: PartDiagnosticStatus.Fail,
  [PartStatus.Blocked]: PartDiagnosticStatus.Fail,
  [PartStatus.RepairNotAuthorized]: PartDiagnosticStatus.Fail,
}

export const PartStatusIcons: Record<PartStatus, string> = {
  [PartStatus.Good]: 'material-symbols:check',
  [PartStatus.Fail]: 'material-symbols:close',
  [PartStatus.Irreparable]: 'material-symbols:pen-size-2',
  [PartStatus.Unrepairable]: 'mdi:prohibited',
  [PartStatus.Replaced]: 'mdi:counterclockwise-arrows',
  [PartStatus.Repaired]: 'mdi:wrench-outline',
  [PartStatus.Blocked]: 'material-symbols:exclamation',
  [PartStatus.RepairNotAuthorized]: 'material-symbols:gpp-bad-outline',
}

export const NO_PART_STATUS_ICON = 'mdi:horizontal-line'

export const PartStatusTagTypes: Record<PartStatus, any> = {
  [PartStatus.Good]: 'success',
  [PartStatus.Fail]: 'danger',
  [PartStatus.Irreparable]: 'danger',
  [PartStatus.Unrepairable]: 'danger',
  [PartStatus.Replaced]: 'success',
  [PartStatus.Repaired]: 'success',
  [PartStatus.Blocked]: 'info',
  [PartStatus.RepairNotAuthorized]: 'info',
}

export const NO_PART_STATUS_TAG_TYPE = 'info'

// UnoCSS colors
export const PartStatusBadgeBgColor: Record<PartStatus, string> = {
  [PartStatus.Good]: 'fill-success',
  [PartStatus.Fail]: 'fill-error',
  [PartStatus.Irreparable]: 'fill-error',
  [PartStatus.Unrepairable]: 'fill-error',
  [PartStatus.Replaced]: 'fill-success',
  [PartStatus.Repaired]: 'fill-success',
  [PartStatus.Blocked]: 'fill-error',
  [PartStatus.RepairNotAuthorized]: 'fill-tertiary',
}
